import { useMutation } from '@tanstack/react-query'

import { GET_MEMBERS_QUERY } from '@/hooks/queries/use-get-members'
import { queryClient } from '@/services/query-client'
import { updateUserRole } from '@/services/update-user-role'

export const useUpdateUserRole = () => {
  const mutation = useMutation({
    mutationFn: updateUserRole,
    onSuccess: () => queryClient.invalidateQueries([GET_MEMBERS_QUERY]),
  })

  return mutation
}
